import {
  ReferenceDataState,
  PhonePrefixElement,
  CountryCodeElement,
  AddressTypeElement
} from './referenceData.model';

const reducers = {
  storePhonePrefixes: (
    state: ReferenceDataState,
    phonePrefixes: PhonePrefixElement[]
  ) => ({ ...state, phonePrefixes }),
  storeCountryCodes: (
    state: ReferenceDataState,
    countryCodes: CountryCodeElement[]
  ) => ({ ...state, countryCodes }),
  storeCountyCodes: (state: ReferenceDataState, counties: string[]) => ({
    ...state,
    countyCodes: counties
  }),
  storeAddressType: (
    state: ReferenceDataState,
    addressTypes: AddressTypeElement[]
  ) => ({
    ...state,
    addressTypes
  })
};

export default reducers;
